import { fork } from "redux-saga/effects";
import auth from "./components/auth/sagas";

const watchAuth = [
  fork(auth),
];

export { watchAuth };
